module.exports = __webpack_public_path__ + "static/media/user.14cf119e.svg";